import AttachmentsList from '@app/components/AttachmentsList'
import CityProfileDetails from '@app/components/CityProfileDetails'
import DemographicsView from '@app/components/DemographicsView'
import PageSection from '@app/components/PageSection'
import PhotoStrip from '@app/components/PhotoStrip'
import RaceEthnicityBreakdownView from '@app/components/RaceEthnicityBreakdownView'
import { ICityProfile } from '@app/models/CityProfile'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { DevelopmentSiteViewPageProps } from './DevelopmentSiteViewPage'

export default class DevelopmentSiteCityProfile extends React.PureComponent<
  DevelopmentSiteViewPageProps
> {
  public componentDidMount() {
    if (this._shouldLoadCityProfile()) {
      this.props.loadCityProfile(
        this.props.site.address.placeFIPS,
        this.props.site.address.stateFIPS,
      )
    }
  }

  public componentDidUpdate() {
    if (this._shouldLoadCityProfile()) {
      this.props.loadCityProfile(
        this.props.site.address.placeFIPS,
        this.props.site.address.stateFIPS,
      )
    }
  }

  public render() {
    if (this.props.isLoadingCityProfile) {
      return (
        <DocumentTitle
          title={`${this.props.site.client.name} :: ${formatAddressSingleLine(
            this.props.site.address,
          )} :: City Profile`}
        >
          <div className='text-center'>Retrieving city profile</div>
        </DocumentTitle>
      )
    }

    if (!this.props.cityProfile) {
      return (
        <DocumentTitle
          title={`${this.props.site.client.name} :: ${formatAddressSingleLine(
            this.props.site.address,
          )} :: City Profile`}
        >
          <div className='text-center'>
            Unable to retrieve city profile right now. Try back later.
          </div>
        </DocumentTitle>
      )
    }

    return (
      <DocumentTitle
        title={`${this.props.site.client.name} :: ${formatAddressSingleLine(
          this.props.site.address,
        )} :: City Profile`}
      >
        <div>
          {this._renderOverviewSpecialFiles(this.props.cityProfile)}
          {this._renderDemographics(this.props.cityProfile)}
          {this._renderRaceEthnicityBreakdown(this.props.cityProfile)}
          {this._renderPhotos(this.props.cityProfile)}
          {this._renderAttachments(this.props.cityProfile)}
        </div>
      </DocumentTitle>
    )
  }

  private _renderAttachments(cityProfile: ICityProfile) {
    return (
      <PageSection title='Attachments'>
        <AttachmentsList
          attachments={cityProfile.attachments}
          onChange={this.props.setCityProfileAttachments}
        />
      </PageSection>
    )
  }

  private _renderDemographics(cityProfile: ICityProfile) {
    if (!cityProfile.demographics) {
      return null
    }

    return (
      <PageSection title='Demographics'>
        <DemographicsView demographics={cityProfile.demographics} />
      </PageSection>
    )
  }

  private _renderOverviewSpecialFiles(cityProfile: ICityProfile) {
    return (
      <PageSection title={cityProfile.place.cityState}>
        <CityProfileDetails cityProfile={cityProfile} />
      </PageSection>
    )
  }

  private _renderPhotos(cityProfile: ICityProfile) {
    return (
      <PageSection title='Photos'>
        <PhotoStrip photos={cityProfile.photos} />
      </PageSection>
    )
  }

  private _renderRaceEthnicityBreakdown(cityProfile: ICityProfile) {
    if (
      !cityProfile.demographics ||
      !cityProfile.demographics.raceEthnicityBreakdown
    ) {
      return null
    }

    return (
      <PageSection title='Race / Ethnicity Breakdown'>
        <RaceEthnicityBreakdownView
          raceEthnicityBreakdown={
            cityProfile.demographics.raceEthnicityBreakdown
          }
        />
      </PageSection>
    )
  }

  private _shouldLoadCityProfile() {
    return (
      this.props.cityProfile === undefined ||
      this.props.cityProfile.place.stateFIPS !==
        this.props.site.address.stateFIPS ||
      this.props.cityProfile.place.placeFIPS !==
        this.props.site.address.placeFIPS
    )
  }
}
